import successGif from "src/assets/icons/success.gif";

const SuccessIcon = () => {
  return <img style={{ height: "80px", width: "80px" }} src={successGif} />;
};

export default SuccessIcon;
